// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/ecom_storefront_access_token_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/ecom_storefront_access_token_response.proto.
 */
export const file_responses_v1_ecom_storefront_access_token_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjhyZXNwb25zZXMvdjEvZWNvbV9zdG9yZWZyb250X2FjY2Vzc190b2tlbl9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIjkKIUVjb21TdG9yZWZyb250QWNjZXNzVG9rZW5SZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAlCkQEKEGNvbS5yZXNwb25zZXMudjFCJkVjb21TdG9yZWZyb250QWNjZXNzVG9rZW5SZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM'
    );

/**
 * @generated from message responses.v1.EcomStorefrontAccessTokenResponse
 */
export type EcomStorefrontAccessTokenResponse = Message<'responses.v1.EcomStorefrontAccessTokenResponse'> & {
    /**
     * @generated from field: string access_token = 1;
     */
    accessToken: string;
};

/**
 * Describes the message responses.v1.EcomStorefrontAccessTokenResponse.
 * Use `create(EcomStorefrontAccessTokenResponseSchema)` to create a new message.
 */
export const EcomStorefrontAccessTokenResponseSchema: GenMessage<EcomStorefrontAccessTokenResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_ecom_storefront_access_token_response, 0);
